/**
 * TokenManager: Zentrale Verwaltung von Auth-Token und Events
 * Notifiziert Komponenten, wenn Tokens aktualisiert oder invalidiert werden
 */

class TokenManager {
  constructor() {
    this.listeners = [];
    this.isRefreshing = false;
    this.refreshSubscribers = [];
  }

  /**
   * Registriert einen Listener für Token-Änderungen
   * @param {Function} callback - Wird aufgerufen bei Token-Änderungen/Invalidierung
   */
  onTokenChange(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(listener => listener !== callback);
    };
  }

  /**
   * Notifiziert alle Listener über Token-Änderung
   */
  notifyTokenChange(type = 'refresh') {
    this.listeners.forEach(listener => listener({ type }));
  }

  /**
   * Speichert Token und Refresh-Token
   */
  setTokens(accessToken, refreshToken) {
    localStorage.setItem('token', accessToken);
    if (refreshToken) {
      localStorage.setItem('refreshToken', refreshToken);
    }
    this.notifyTokenChange('set');
  }

  /**
   * Holt aktuellen Access-Token
   */
  getToken() {
    return localStorage.getItem('token');
  }

  /**
   * Holt Refresh-Token
   */
  getRefreshToken() {
    return localStorage.getItem('refreshToken');
  }

  /**
   * Invalidiert alle Tokens (bei Logout oder Token-Fehler)
   */
  clearTokens() {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    this.notifyTokenChange('logout');
  }

  /**
   * Gibt an, ob gerade ein Refresh läuft
   */
  setRefreshing(isRefreshing) {
    this.isRefreshing = isRefreshing;
  }

  /**
   * Prüft, ob ein Refresh aktuell läuft
   */
  getIsRefreshing() {
    return this.isRefreshing;
  }

  /**
   * Subscriber-System für Refresh-Requests (nur ein Refresh gleichzeitig)
   */
  subscribeTokenRefresh(callback) {
    this.refreshSubscribers.push(callback);
  }

  /**
   * Notifiziert alle Subscriber nach erfolgreichen Refresh
   */
  onRefreshed(token) {
    this.refreshSubscribers.forEach(callback => callback(token));
    this.refreshSubscribers = [];
  }

  /**
   * Reset bei Refresh-Fehler
   */
  onRefreshFailed() {
    this.refreshSubscribers = [];
  }
}

// Singleton-Instanz
const tokenManager = new TokenManager();

export default tokenManager;
